<template>
  <div class='massLoss-list'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1'>
        <el-form-item label='船舶名称：'>
          <el-input v-model='searchForm.cnShipName' size='mini' placeholder='请输入船舶名称' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='searchBtn' @click='realTimeQuery'>实时查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='cnShipName' label='船名' align='center' min-width='180px' />
          <el-table-column prop='voyageNumber' label='航次' align='center' min-width='150px' />
          <el-table-column prop='route' label='航线' align='center' min-width='180px' />
          <el-table-column prop='shipPosition' label='船位' align='center' min-width='180px' />
          <el-table-column prop='mileage' label='里程' align='center' min-width='100px' />
          <el-table-column prop='navStatus' label='航行状态' align='center' min-width='100px' />
          <el-table-column prop='recvTime' label='信息时间' align='center' min-width='200px' />
          <el-table-column prop='sog' label='航速（节）' align='center' min-width='200px' />
          <el-table-column prop='cog' label='航迹向' align='center' min-width='200px' />
          <el-table-column prop='trueHead' label='船首向' align='center' min-width='200px' />
          <el-table-column prop='lng' label='经度' align='center' min-width='200px' />
          <el-table-column prop='lat' label='维度' align='center' min-width='200px' />
          <el-table-column label='操作' width='200px' align='center'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' @click='rowEdit(scope.row.id)'>修改</el-button>
              <el-button size='mini' type='warning' @click='track("跟踪", scope.row)'>地图跟踪
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <ship-tracking-form ref='shipTrackingFormRef' @searchBtn='searchBtn' />

    <el-dialog :title='dialogTitle' :visible.sync='mapDialogVisible' width='850px' center
               :close-on-click-modal='false'>
      <div style='height: 700px;'>
        <!-- 放地图 -->
        <route-map v-if='mapDialogVisible' ref='routeMap' />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { shipTracking, shipTrackingDateInsert, shipTrackingPage } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import ShipTrackingForm from './components/shipTrackingForm.vue';
  import RouteMap from './components/routeMap.vue';

  export default {
    name: 'supplierSpecialPrice',
    components: {
      ShipTrackingForm,
      RouteMap,
    },
    data() {
      return {
        searchForm: {
          cnShipName: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        dialogTitle: '',
        mapDialogVisible: false,
        lineArr: [],//轨迹回放坐标
        center: [],//当前位置
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    //  this.searchBtn();
    },
    methods: {
      async realTimeQuery() {
        this.tableLoading = true;
        const {
          status,
          message,
        } = await shipTrackingDateInsert();
        if (status !== 0) return this.$message.warning(message);
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/voyage/tracking/shipTrackingExport?access_token=${token}&cnShipName=${this.searchForm.cnShipName}`;
        window.exportExcelGet('/platform/voyage/tracking/shipTrackingExport', `cnShipName=${this.searchForm.cnShipName}`);
      },
      getType(type) {
        switch (type) {
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装卸费';
          case 4:
            return '过驳费';
          case 5:
            return '提车费';
          case 6:
            return '堆存费';
          default:
            return '--';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const data = await shipTrackingPage(this.searchForm);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      rowEdit(id) {
        this.$refs.shipTrackingFormRef.dialogOpen(id);
      },
      async track(title, row) {
        this.dialogTitle = title;
        //当前位置
        // let res = await shipTracking({ mmsi });
        // if (res.status !== 0) return this.$message.error(res.message);
        // console.log(res);
        // this.lineArr = res.data;
        // this.center = res.data[0];
        // this.center = res.data[res.data.length-2];
        this.mapDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.routeMap.init(row);
        });

      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
